import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import DashboardLayout from '@components/layout/DashboardLayout'
import FinancialOverview from './FinancialOverview'
import OperationalMetrics from './OperationalMetrics'
import StrategicInsights from './StrategicInsights'
import MarketAnalysis from './MarketAnalysis'
import VendorPerformance from './VendorPerformance'

const PartnerPortal: React.FC = () => {
  const menuItems = [
    { path: 'financial', label: 'Financial Overview', icon: 'AttachMoney' },
    { path: 'operations', label: 'Operational Metrics', icon: 'Dashboard' },
    { path: 'insights', label: 'Strategic Insights', icon: 'TrendingUp' },
    { path: 'market', label: 'Market Analysis', icon: 'Assessment' },
    { path: 'vendors', label: 'Vendor Performance', icon: 'People' }
  ]

  return (
    <DashboardLayout title="TanOak Partner Portal" menuItems={menuItems}>
      <Box sx={{ p: 3 }}>
        <Routes>
          <Route path="/" element={<Navigate to="financial" replace />} />
          <Route path="financial" element={<FinancialOverview />} />
          <Route path="operations" element={<OperationalMetrics />} />
          <Route path="insights" element={<StrategicInsights />} />
          <Route path="market" element={<MarketAnalysis />} />
          <Route path="vendors" element={<VendorPerformance />} />
        </Routes>
      </Box>
    </DashboardLayout>
  )
}

export default PartnerPortal